import { ReactNode } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { COLOR_ACCENT, COLOR_BG_BLACK, TRANSITION_300 } from 'shared/config';

export interface LinkBlockProps {
  title?: string;
  link: {
    href: string;
    text: string;
    icon?: ReactNode;
  };
}

export const LinkBlock = ({ title, link }: LinkBlockProps) => {
  return (
    <Box mt={4}>
      {title && (
        <Typography color="#606060" fontSize={15}>
          {title}
        </Typography>
      )}
      <Typography>
        {link.icon}{' '}
        <Link
          href={link.href}
          referrerPolicy="no-referrer"
          rel="noreferrer"
          target="_blank"
          underline="always"
          color={COLOR_BG_BLACK}
          fontWeight={500}
          sx={{
            transition: TRANSITION_300,
            '&:hover': {
              color: COLOR_ACCENT,
            },
          }}
        >
          {link.text}
        </Link>
      </Typography>
    </Box>
  );
};
